export default "__VITE_ASSET__PmZfzMug73R2On9X9HfsUQ__"